// 挂载 $syRouter，用来 layout-wrap 布局文件中, 因为3端公用所以抽出来
// 依赖：vm.$route，vm.pageFrame, vm.$router, vm.$refs.layoutTab
export default function initSyRouter (vm) {
  window.fe.vue.prototype.$syRouter = {
    back: () => {
      vm.$route.meta?.noTabFrame
        ? vm.$router.back()
        : vm.pageFrame === '1'
          ? vm.$refs.layoutTab?.back()
          : vm.$router.back()
    },
    open: (location, strWindowName, strWindowFeatures) => {
      if (vm.pageFrame === '1') {
        vm.$router.push(location)
      } else {
        let { href } = vm.$router.resolve(location)
        return window.open(href, strWindowName, strWindowFeatures)
      }
    },
    reset () {
      if (vm.pageFrame === '1') {
        vm.$refs.layoutTab?.reset()
      }
    }
  }
}